import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import ChipEdit from 'ChipEdit';
import transform from '../../../common/transform';
import { QQShare } from 'ThreeTerminal_mobile_dynamic';
import { addEventListener } from '@ifeng-fe/ui_base';
import { handleTjLink } from '@ifeng-fe/container_content/common/client/utils/utils';
import Header from './header';
import Content from './content';

class Layout extends React.PureComponent {
    static propTypes = { content: PropTypes.object };

    state = {
        txtShow: true,
    };

    async componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) {
            window.BJ_REPORT.firstScreen();
            window.BJ_REPORT.mainPagecheck();
        }
        this.unHandleClick = addEventListener(document, 'click', handleTjLink);
    }

    componentWillUnmount() {
        this.unHandleClick();
    }

    handleTxtShow = () => {
        const { txtShow } = this.state;

        this.setState({
            txtShow: !txtShow,
        });
    };

    render() {
        const { txtShow } = this.state;
        const {
            content: { channel, docData, comment, downloads, bannerAd, interact },
        } = this.props;

        const headerData = {
            channel,
            downloads,
            docData,
            comment,
            interact,
        };

        const qqShareCofig = {
            title: docData.title,
            img:
                (docData.imagesInContent && docData.imagesInContent[0] && docData.imagesInContent[0].url) ||
                'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: docData.summary || docData.title || '',
            cb: () => {
                console.log('分享成功');
            },
        };

        return (
            <React.Fragment>
                <NoSSR>
                    <Header content={headerData} txtShow={txtShow} />
                </NoSSR>
                <Content content={docData} bannerAd={bannerAd} txtShow={txtShow} handleTxtShow={this.handleTxtShow} />
                <QQShare content={qqShareCofig} />
                <ChipEdit transform={transform} />
            </React.Fragment>
        );
    }
}

export default Layout;
